export default __webpack_public_path__ + "static/media/send-icon.359145cc.svg";